<template>
  <div :class="isSpanBySpan ? 'is-spanBySpan' : ''">
    <div class="u-df u-jcsb u-aifs">
      <div v-if="!isSpanBySpan">
        <calc-number-input
          v-model="singleVal"
          :precision="0"
          :min="0"
          :max="10"
          :disabled="disabled"
          key="singleVal"
          @keydown.native.once="handleKeydown"
        />
      </div>

      <div class="line"></div>

      <b-switch
        :disabled="disabled"
        v-model="isSpanBySpan"
        @input.once="handleSwitch"
        class="is-label_left zswitch"
        >{{ $t("Definir valor por vão") }}</b-switch
      >
    </div>

    <div class="fields_grid" v-if="isSpanBySpan">
      <calc-number-input
        v-for="(span, i) in displaySpanRestraints"
        v-model="displaySpanRestraints[i]"
        :key="i"
        :min="0"
        :max="10"
        :precision="0"
        :label="`${$t('Vão')} #${i + 1}`"
        :disabled="disabled"
        @keydown.native.once="handleKeydown"
      />
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { withoutDuplicates } from "@/utils";

export default {
  model: {
    prop: "displaySpanRestraints",
  },

  props: {
    displaySpanRestraints: {
      required: true,
      type: Array,
    },

    disabled: {
      default: false,
    },
  },

  data() {
    return {
      activated: false,
      isSpanBySpan: undefined,
      unwatchIsSpanBySpan: undefined,
    };
  },

  computed: {
    singleVal: {
      get() {
        return this.displaySpanRestraints[0];
      },

      set(val) {
        this.$emit("input", Array(this.displaySpanRestraints.length).fill(val));
      },
    },
  },

  // watch: {
  // 	isSpanBySpan(val) {
  // 		const { displaySpanRestraints, singleVal } = this;

  // 		if (!val) {
  // 			// SWITCH OFF
  // 			this.$emit(
  // 				"input",
  // 				Array(displaySpanRestraints.length).fill(singleVal)
  // 			);
  // 		}
  // 	},
  // },

  methods: {
    ...mapMutations("calculator", ["setIsSpanRestraintsManuallyChanged"]),

    handleKeydown() {
      this.setIsSpanRestraintsManuallyChanged({ val: true });
    },

    handleSwitch() {
      this.setIsSpanRestraintsManuallyChanged({ val: true });
    },

    onCreateOrActivate() {
      if (this.activated) return;
      this.activated = true;

      this.isSpanBySpan =
        withoutDuplicates(this.displaySpanRestraints).length !== 1;

      this.unwatchIsSpanBySpan = this.$watch("isSpanBySpan", (val) => {
        const { displaySpanRestraints, singleVal } = this;

        if (!val) {
          // SWITCH OFF
          this.$emit(
            "input",
            Array(displaySpanRestraints.length).fill(singleVal)
          );
        }
      });
    },

    onDeactivate() {
      if (!this.activated) return;
      this.activated = false;
      this.unwatchIsSpanBySpan && this.unwatchIsSpanBySpan();
    },
  },

  created() {
    this.onCreateOrActivate();
  },

  activated() {
    this.onCreateOrActivate();
  },

  deactivated() {
    this.onDeactivate();
  },
};
</script>

<style lang="scss" scoped>
.line {
  flex-grow: 1;
  height: 1px;
  background-color: #eee;
  position: relative;
  top: 15px;
  margin: 0 15px;
}

.is-spanBySpan {
  .line {
    margin-left: 0;
  }
}

.zswitch {
  margin-top: 5px;
}

.fields_grid {
  padding-top: 16px;
}
</style>
